module.exports = __webpack_public_path__ + "static/media/fly0059.960d2cff.webp";